module.exports = {
  m2: 1,
  unit: 2,
  m3: 3,
  ml: 4,
  mm: 5,
  g: 6,
};
